export default {
	"type": "object",
	"properties": {
		"search": {
			"inputType": "search",
			"type": "string",
		}
	}
};